<template>
  <section id="timerBar">
    <div id="selectGroup">
      <cat-dropdown></cat-dropdown>
    </div>
    <timer-widget id="timer"></timer-widget>
    <nav-tabs id="nav"></nav-tabs>
  </section>
</template>

<script>
import TimerWidget from '@/components/GameProfits/TimerWidget';
import NavTabs from "@/components/Shared/NavTabs";
import CatDropdown from "@/components/GameProfits/CatDropdown";
export default {
  components: {
    TimerWidget,
    NavTabs,
    CatDropdown,
  },
};
</script>

<style lang="scss" scoped>

#timerBar {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: $text_grey2;
  margin: 60px 0px 0px 0px;

  @include respond(desktop-sm) {
    flex-direction: column;
  }
}


#selectGroup {
    display:flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin:0px 10px 0px 10px;
    order:1;

    @include respond(desktop-sm) {
    order:3;
    margin:0px 10px 0px 10px;
    flex-direction: column;
    justify-content: center;
    align-items:center;
  }
}

#timer {
    order:2;
    
    @include respond(desktop-sm) {
    order:2;
    margin:0px 0px 40px 0px;
  }
}

#nav {
    order:3;
    @include respond(desktop-sm) {
    order:1;
    margin:0px 0px 60px 10px;
  }
}
</style>